import { Map } from 'immutable';

import { updateListingScore } from '../../product/score';
import { getOversetValue } from '../../product/checkAttribute';
import { escapeRegex } from '../../string';

import { FIND, OPERATIONS, REPLACE } from '../../../constants/bulkEdit';
import { OVERSET, VALUE } from '../../../constants/product';
import { ATTRIBUTE } from '../../../constants/attributes';
import { SHOPIFY } from '../../../constants/channels';
import { FORM } from '../../../constants/forms';

export default function seoDescription({ actions, operation, product }) {
  function setValueToProduct(value) {
    const result = {
      actions,
      product: product.setIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, VALUE], value),
    };

    const overset = getOversetValue({ attribute: ATTRIBUTE.PAGE_TITLE, product: result.product });

    if (!value) {
      result.product = result.product.setIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION],
        Map({ [OVERSET]: true, [VALUE]: overset })
      );
    } else if (value === overset) {
      result.product = result.product.setIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, OVERSET], true);
    } else if (result.product.getIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, OVERSET])) {
      result.product = result.product.deleteIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, OVERSET]);
    }

    if (result.product.hasIn(['score', ATTRIBUTE.META_DESCRIPTION])) {
      result.product = updateListingScore(result.product);
    }

    return result;
  }

  switch (operation.get('type')) {
    case OPERATIONS[SHOPIFY].META_DESCRIPTION.SET: {
      const value = operation.get(VALUE);
      return setValueToProduct(value);
    }

    case OPERATIONS[SHOPIFY].META_DESCRIPTION.DELETE: {
      const pattern = new RegExp(escapeRegex(operation.get(VALUE)), 'ig');
      const value = product.getIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, VALUE]).replace(pattern, '');
      return setValueToProduct(value);
    }

    case OPERATIONS[SHOPIFY].META_DESCRIPTION.ADD_AFTER: {
      const value = `${product.getIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, VALUE])}${operation.get(VALUE)}`;
      return setValueToProduct(value);
    }

    case OPERATIONS[SHOPIFY].META_DESCRIPTION.ADD_BEFORE: {
      const value = `${operation.get(VALUE)}${product.getIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, VALUE])}`;
      return setValueToProduct(value);
    }

    case OPERATIONS[SHOPIFY].META_DESCRIPTION.FIND_AND_REPLACE: {
      const pattern = new RegExp(escapeRegex(operation.getIn([VALUE, FIND])), 'ig');
      const value = product
        .getIn([FORM.SEO, ATTRIBUTE.META_DESCRIPTION, VALUE])
        .replace(pattern, operation.getIn([VALUE, REPLACE]));

      return setValueToProduct(value);
    }

    default: {
      return { actions, product };
    }
  }
}
